import CryptoJS from 'crypto-js';
import jwt from 'jsonwebtoken';

import store from './../store/store';

const p = '2@%eGH[Qnad?#*P%#axHm1tlSre6Q8';
const w = 'NE8Lw]FLAZlST3*H2rGppQW13,Mp6q';

export function saveListEmpresas(value) {
  localStorage.setItem(
    'listEmpresas',
    CryptoJS.AES.encrypt(JSON.stringify(value), p + w).toString(),
  );

  updateStoreDataEmpresa();
}

export function saveDataLoginDefault({
  idEmpresa,
  userToken = null,
  systemNotice = {},
}) {
  let decoded = { id_usuario: null };

  if (userToken) {
    decoded = jwt.decode(userToken);
  }

  const dataLoginDefault = {
    idUsuarioInitialLogin: decoded.id_usuario,
    idEmpresaDefault: idEmpresa,
    systemNotice,
    nomeUsuarioDefault: decoded.nome || '',
  };

  localStorage.setItem(
    'dataLoginDefault',
    CryptoJS.AES.encrypt(JSON.stringify(dataLoginDefault), p + w).toString(),
  );
}

export function getDataLoginDefault() {
  const dataLoginDefaultCrypto = localStorage.getItem('dataLoginDefault');

  if (dataLoginDefaultCrypto) {
    const bytes = CryptoJS.AES.decrypt(dataLoginDefaultCrypto, p + w);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  return null;
}

export function updateStoreDataEmpresa() {
  // Lista de Empresas
  const listEmpresaCrypto = localStorage.getItem('listEmpresas');

  if (listEmpresaCrypto) {
    const bytes = CryptoJS.AES.decrypt(listEmpresaCrypto, p + w);
    const listEmpresa = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    store.dispatch('updateListEmpresa', listEmpresa);
  }

  // Logo
  const logo = localStorage.getItem('logo');
  store.dispatch('updateLogo', logo);

  const dataLoginDefault = getDataLoginDefault();

  // Empresa Atual
  const idEmpresa = +(localStorage.getItem('idEmpresa') || dataLoginDefault.idEmpresaDefault);
  store.dispatch('updateCurrentEmpresa', idEmpresa);

  // Usuario Logado (inicialmente)

  if (dataLoginDefault) {
    const { idUsuarioInitialLogin } = dataLoginDefault;

    if (idUsuarioInitialLogin) {
      store.dispatch('updateIdUsuarioInitialLogin', idUsuarioInitialLogin);
    }
  }

  // Nome do Usuário Atual
  const userToken = localStorage.getItem('user-token');
  const decoded = jwt.decode(userToken);
  store.dispatch('updateNomeCurrentUsuario', decoded ? decoded.nome : dataLoginDefault.nomeUsuarioDefault);
}

